var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerch01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.997px",
    height: "15.999px",
    viewBox: "79.546 153.56 15.997 15.999",
    enableBackground: "new 79.546 153.56 15.997 15.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#01b454",
    d: "M95.434,168.636c-0.064-0.093-0.149-0.173-0.23-0.254 c-1.156-1.156-2.307-2.318-3.474-3.464c-0.202-0.198-0.226-0.313-0.044-0.546c0.927-1.191,1.362-2.558,1.37-4.063 c0.006-0.408-0.028-0.813-0.107-1.212c-1.004-5.052-6.763-7.214-10.845-4.072c-2.99,2.301-3.432,6.868-0.937,9.681 c2.451,2.762,6.287,3.16,9.251,0.953c0.177-0.133,0.267-0.133,0.426,0.029c1.17,1.187,2.352,2.361,3.531,3.539 c0.081,0.08,0.162,0.165,0.255,0.229c0.243,0.163,0.542,0.128,0.742-0.076C95.573,169.176,95.602,168.879,95.434,168.636z  M86.271,165.885c-3.094-0.028-5.569-2.536-5.543-5.614c0.026-3.064,2.542-5.547,5.602-5.527c3.07,0.02,5.555,2.525,5.539,5.586 C91.854,163.422,89.341,165.914,86.271,165.885z M83.041,157.289c-0.707,0.766-1.067,1.672-1.09,2.775 c0.002,0.051,0.008,0.165,0.015,0.279c0.026,0.432,0.257,0.675,0.624,0.656c0.359-0.018,0.579-0.297,0.554-0.724 c-0.051-0.843,0.204-1.573,0.774-2.198c0.272-0.297,0.275-0.654,0.028-0.888C83.687,156.945,83.322,156.984,83.041,157.289z"
  })))), "asfs\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerch01);
export default __webpack_public_path__ + "static/media/serch-01.e5dd6382a493c386032ab2ac0283de7c.svg";
export { ForwardRef as ReactComponent };